import { defineMessages } from 'react-intl';

export const searchRecordAggregation = defineMessages({
  'dt:search_record_aggregation:group': {
    id: 'search_record_aggregation.group.title',
    defaultMessage: 'Group',
    value: 'group',
  },
  'dt:search_record_aggregation:sum': {
    id: 'search_record_aggregation.sum.title',
    defaultMessage: 'Sum',
    value: 'sum',
  },
  'dt:search_record_aggregation:count': {
    id: 'search_record_aggregation.count.title',
    defaultMessage: 'Count',
    value: 'count',
  },
  'dt:search_record_aggregation:average': {
    id: 'search_record_aggregation.average.title',
    defaultMessage: 'Average',
    value: 'avg',
  },
  'dt:search_record_aggregation:min': {
    id: 'search_record_aggregation.min.title',
    defaultMessage: 'Min',
    value: 'min',
  },
  'dt:search_record_aggregation:max': {
    id: 'search_record_aggregation.max.title',
    defaultMessage: 'Max',
    value: 'max',
  },
});

export const searchRecordOrder = defineMessages({
  'dt:search_record_order:ascending': {
    id: 'search_record_order.ascending.title',
    defaultMessage: 'Ascending',
    value: 'ASC',
  },
  'dt:search_record_order:descending': {
    id: 'search_record_order.descending.title',
    defaultMessage: 'Descending',
    value: 'DESC',
  },
});
